export default {
    data(){
      return{
          preLoader: false,
          isActivityModal:false,
          isNoteModal:false,
          value: '',
          activitiesList: [],
          rowData: {},
          noteRowData:null,
          today: {dateOnly: moment().format('YYYY-MM-DD')},

          activitiesFilter: [
              {
                  name: 'Todo',
                  key: 'status=9'
              },
              {
                  name: 'Done',
                  key: 'status=10'
              },
              {
                  name: 'Incomplete',
                  key: 'incomplete'
              },
              {
                  name: 'Files',
                  key: 'file'
              },
              {
                  name: 'Notes',
                  key: 'note'
              }
          ],
      }
    },
    methods:{
        filterActivities(url, key) {
            this.preLoader = false
            this.value = key;
            this.axiosGet( `${url}${this.formData.id}?${this.value}`).then(response => {
                this.activitiesList = response.data;
                this.preLoader = true;
            }).catch((error) => console.log(error))
        },
        activityChangeStatus(id){
            this.preLoader = true
            this.axiosPost({
                url: `crm/activities/done/${id}`
            }).then((response) => {
                this.$toastr.s(response.data.message);
                this.filterActivities(this.activitiesFilterUrl, 'status=9');
            }).finally(() => {
                this.preLoader = false;
            }).catch((error) => console.log(error));
        },
        activityDelete(id) {
            this.axiosDelete(`crm/activities/${id}`).then((response) => {
                this.$toastr.e(response.data.message);
                this.filterActivities(this.activitiesFilterUrl, 'status=9');
            }).catch((error) => console.log(error));
        },

        editActivity(activity){
            this.isActivityModal = true;
            this.rowData = activity;
            $('#common-activity-modal').modal('show');

        },

        fileDownload(activity){
            this.axiosGet(`crm/file/download/${activity.id}`, {responseType: 'blob'}).then((response) => {
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'activity'+activity.path);
                document.body.appendChild(fileLink);
                fileLink.click();
            })
        },

        editNote(activity) {
            this.isNoteModal = true;
            this.noteRowData = activity;
            $('#note-modal').modal('show');
        },

        noteDelete(id){
            this.axiosDelete(`crm/note/delete/${id}`).then((response) => {
                this.$toastr.e(response.data.message);
                this.filterActivities(this.activitiesFilterUrl, 'note');
            }).catch((error) => console.log(error));
        },

        closeNoteModal(){
            this.isNoteModal = false;
            this.noteRowData = null;
            $('#note-modal').modal('hide');
        },

        closeActivityModal(){
            this.isActivityModal = false;
            this.rowData = {};
            $('#common-activity-modal').modal('hide');
        },
    }
}
